module.exports = __webpack_public_path__ + "static/img/Josh_Kennedy_mobile.f3a290a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josh_Kennedy_mobile.jpg
// module id = ujOv
// module chunks = 0